
export default class Location {
    constructor(id, cscom) {
        if (!(this instanceof Location)) {
            return new Location(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/locations/${this.id}`;
        } else {
            this.path = `/user-site-api/locations`;
        }
    }

    listAll() {
        return this.cscom.req.get(this.path, { limit: 9999 }).then((result) => {
            return result._embedded.items;
        });
    }

    update(body) {
        return this.cscom.req.put(this.path, body).then((result) => {
            return result;
        });
    }

    add(body) {
        return this.cscom.req.post(this.path, body).then((result) => {
            return result;
        });
    }

    remove() {
        return this.cscom.req.del(this.path).then((result) => {
            return result;
        });
    }

    sync() {
        return this.cscom.req.post(`/user-site-api/synclocations`).then((result) => {
            //return result;
            return "success";
        });
    }
    
}
